import React from 'react';
import { FaSyncAlt } from 'react-icons/fa';
import { UNAVAILABLE_TITLE } from './dataView';

interface DataUnavailableProps {
    /** One short reason, in the console's words. */
    reason: string;
    /** The API's own sentence, as a tooltip on the reason. */
    detail?: string;
    onRetry: () => void;
}

/**
 * The whole view's state when no call to this database can work (DESIGN_V1.md D13): the title, ONE short reason, and
 * Try again. No repair action, on purpose: the helper is installed only when a database is created, and a customer
 * who changes it on their own machine loses the feature rather than being offered a fix that could not hold.
 */
const DataUnavailable: React.FC<DataUnavailableProps> = ({ reason, detail, onRetry }) => (
    <div className="db-data-unavailable" role="status">
        <h3>{UNAVAILABLE_TITLE}</h3>
        <p className="db-data-unavailable-reason" title={detail}>{reason}</p>
        <button type="button" className="btn btn-secondary" onClick={onRetry}>
            <FaSyncAlt /> Try again
        </button>
    </div>
);

export default DataUnavailable;
